module.exports = __webpack_public_path__ + "static/media/SBPhotography_1-1022w.fcb8d30d.webp";